import { Map } from 'immutable';
import core from './core';

const INITIAL_STATE = new Map({
    list: new Map(),
    initialized: false
});

export default function SDM18MVR(state = INITIAL_STATE, action) {
    switch (action.type) {
        case 'MYFHE__FHEPRODUCT_SET_SDM18MVRS':
            return core.setSDM18MVRs(state, action.SDM18MVRs);
        case 'MYFHE__FHEPRODUCT_UPDATE_SDM18MVRS':
            return core.updateSDM18MVRs(state, action.SDM18MVRs);
        case 'MYFHE__FHEPRODUCT_SET_SDM18MVR_DETAILS':
            return core.setSDM18MVRDetails(state, action.SDM18MVRId, action.SDM18MVRDetails);
        case 'MYFHE__FHEPRODUCT_UPDATE_SDM18MVR_STATUS':
            return core.updateSDM18MVRStatus(state, action.productIdentifier, action.status);
        case 'MYFHE__FHEPRODUCT_MASTER_SWITCH_SDM18MVR':
            return core.switchSDM18MVRMaster(state, action.productIdentifier, action.masterId);
        case 'MYFHE__FHEPRODUCT_DISSOCIATE_USER_SDM18MVR':
            return core.dissociateUserFromSDM18MVR(state, action.productIdentifier, action.userId);
        case 'MYFHE__FHEPRODUCT_DISSOCIATE_USER_AND_SWITCH_MASTER_SDM18MVR':
            return core.dissociateUserFromSDM18MVRAndSwitchMaster(state, action.productIdentifier, action.userId, action.masterId);
    }

    return state;
}



// WEBPACK FOOTER //
// ./environments/myfhe/data/SDM18MVR/reducer.js